/* tslint:disable */
/* eslint-disable */
/**
 * Ory APIs
 * # Introduction Documentation for all public and administrative Ory APIs. Administrative APIs can only be accessed with a valid Personal Access Token. Public APIs are mostly used in browsers.  ## SDKs This document describes the APIs available in the Ory Network. The APIs are available as SDKs for the following languages:  | Language       | Download SDK                                                     | Documentation                                                                        | | -------------- | ---------------------------------------------------------------- | ------------------------------------------------------------------------------------ | | Dart           | [pub.dev](https://pub.dev/packages/ory_client)                   | [README](https://github.com/ory/sdk/blob/master/clients/client/dart/README.md)       | | .NET           | [nuget.org](https://www.nuget.org/packages/Ory.Client/)          | [README](https://github.com/ory/sdk/blob/master/clients/client/dotnet/README.md)     | | Elixir         | [hex.pm](https://hex.pm/packages/ory_client)                     | [README](https://github.com/ory/sdk/blob/master/clients/client/elixir/README.md)     | | Go             | [github.com](https://github.com/ory/client-go)                   | [README](https://github.com/ory/sdk/blob/master/clients/client/go/README.md)         | | Java           | [maven.org](https://search.maven.org/artifact/sh.ory/ory-client) | [README](https://github.com/ory/sdk/blob/master/clients/client/java/README.md)       | | JavaScript     | [npmjs.com](https://www.npmjs.com/package/@ory/client)           | [README](https://github.com/ory/sdk/blob/master/clients/client/typescript/README.md) | | JavaScript (With fetch) | [npmjs.com](https://www.npmjs.com/package/@ory/client-fetch)           | [README](https://github.com/ory/sdk/blob/master/clients/client/typescript-fetch/README.md) |  | PHP            | [packagist.org](https://packagist.org/packages/ory/client)       | [README](https://github.com/ory/sdk/blob/master/clients/client/php/README.md)        | | Python         | [pypi.org](https://pypi.org/project/ory-client/)                 | [README](https://github.com/ory/sdk/blob/master/clients/client/python/README.md)     | | Ruby           | [rubygems.org](https://rubygems.org/gems/ory-client)             | [README](https://github.com/ory/sdk/blob/master/clients/client/ruby/README.md)       | | Rust           | [crates.io](https://crates.io/crates/ory-client)                 | [README](https://github.com/ory/sdk/blob/master/clients/client/rust/README.md)       |
 *
 * The version of the OpenAPI document: v1.20.10
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CustomDomainSslStatusEnum = {
    Initializing: 'initializing',
    PendingValidation: 'pending_validation',
    Deleted: 'deleted',
    PendingIssuance: 'pending_issuance',
    PendingDeployment: 'pending_deployment',
    PendingDeletion: 'pending_deletion',
    PendingExpiration: 'pending_expiration',
    Expired: 'expired',
    Active: 'active',
    InitializingTimedOut: 'initializing_timed_out',
    ValidationTimedOut: 'validation_timed_out',
    IssuanceTimedOut: 'issuance_timed_out',
    DeploymentTimedOut: 'deployment_timed_out',
    DeletionTimedOut: 'deletion_timed_out',
    PendingCleanup: 'pending_cleanup',
    StagingDeployment: 'staging_deployment',
    StagingActive: 'staging_active',
    Deactivating: 'deactivating',
    Inactive: 'inactive',
    BackupIssued: 'backup_issued',
    HoldingDeployment: 'holding_deployment',
    Empty: '',
    UnknownDefaultOpenApi: '11184809'
};
/**
 * Check if a given object implements the CustomDomain interface.
 */
export function instanceOfCustomDomain(value) {
    return true;
}
export function CustomDomainFromJSON(json) {
    return CustomDomainFromJSONTyped(json, false);
}
export function CustomDomainFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'cookie_domain': json['cookie_domain'] == null ? undefined : json['cookie_domain'],
        'cors_allowed_origins': json['cors_allowed_origins'] == null ? undefined : json['cors_allowed_origins'],
        'cors_enabled': json['cors_enabled'] == null ? undefined : json['cors_enabled'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'custom_ui_base_url': json['custom_ui_base_url'] == null ? undefined : json['custom_ui_base_url'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'id': json['id'] == null ? undefined : json['id'],
        'ssl_status': json['ssl_status'] == null ? undefined : json['ssl_status'],
        'updated_at': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'verification_errors': json['verification_errors'] == null ? undefined : json['verification_errors'],
        'verification_status': json['verification_status'] == null ? undefined : json['verification_status'],
    };
}
export function CustomDomainToJSON(json) {
    return CustomDomainToJSONTyped(json, false);
}
export function CustomDomainToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'cookie_domain': value['cookie_domain'],
        'cors_allowed_origins': value['cors_allowed_origins'],
        'cors_enabled': value['cors_enabled'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'custom_ui_base_url': value['custom_ui_base_url'],
        'hostname': value['hostname'],
        'id': value['id'],
        'ssl_status': value['ssl_status'],
        'updated_at': value['updated_at'] == null ? undefined : ((value['updated_at']).toISOString()),
        'verification_errors': value['verification_errors'],
        'verification_status': value['verification_status'],
    };
}
